// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"18":"82be5d6f","54":"866b3427","80":"d8d4ebd1","281":"5e651748","425":"15eb154b","451":"e0e9eac0","616":"b4ecce60","635":"a1ea3189","673":"a72d178c","732":"13b1e205","762":"2a75773b","812":"7f678be5","850":"e45ac240","857":"5d199e10"}[chunkId] + ".chunk.js";
};